<template>
  <div class="d-flex flex-column align-items-center">
    <content-header-custom
      title="Profile"
      class="w-100 mxw-md px-10"
      includeBack
      :subTitle="subTitle"
    >
      <!-- <div class="avatar-section">
        <el-avatar :size="70">Avatar</el-avatar>
        <span class="upload-button">EDIT</span>
      </div> -->
    </content-header-custom>
    <content-body-card class="w-100">
      <el-tabs v-if="loaded" v-model="activeName">
        <el-tab-pane label="Member Profile" name="member-profile" :lazy="true">
          <member-detail v-model="member"/>
        </el-tab-pane>
        <el-tab-pane label="Registration History" name="rego-history" :lazy="true">
          <rego-history v-model="member" />
        </el-tab-pane>
        <el-tab-pane label="Purchase Items" name="purchase-items" :lazy="true">
          <purchase-items v-model="member" />
        </el-tab-pane>
        <el-tab-pane label="Store Purchase History" name="-store-purchase-history" :lazy="true">
          <store-purchase-history v-model="member" />
        </el-tab-pane>
        <el-tab-pane label="Accreditations" name="accreditations">
          <accreditations :member="member" />
        </el-tab-pane>
        <el-tab-pane label="Performances" name="performances" :lazy="true">
          <performances v-if="loaded" :member="member" />
        </el-tab-pane>
        <el-tab-pane label="Bookings" name="bookings" :lazy="true">
          <bookings v-if="loaded" v-model="member" />
        </el-tab-pane>
        <el-tab-pane label="Communications" name="communications" :lazy="true">
          <communications v-if="loaded" v-model="member" />
        </el-tab-pane>

      </el-tabs>
    </content-body-card>
  </div>
</template>

<script>
/* eslint-disable max-len */

import _ from 'lodash';
import playerDetails from '@/mixins/player-details';

export default {
  name: 'Profile',
  mixins: [playerDetails],
  components: {
    MemberDetail: () => import('./components/MemberDetails'),
    RegoHistory: () => import('./components/RegoHistory'),
    Accreditations: () => import('./components/Accreditations'),
    Performances: () => import('./components/Performances'),
    Bookings: () => import('./components/Bookings'),
    Communications: () => import('./components/Communications'),
    PurchaseItems: () => import('./components/PurchaseItems'),
    StorePurchaseHistory: () => import('./components/StorePurchaseHistory'),
  },
  props: {
    tabName: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      activeName: this.tabName ? this.tabName : 'member-profile',
      subTitle:
        'On this screen you can view current member contact information and registration history. Note: Names and DOB are non-editable after the member has been created.',
      loaded: false,
    };
  },
  mounted() {
    const { id } = this.$route.params;
    if (id) {
      this.$store.commit('loading', { loading: true, text: 'Loading...' });
      this.$http.get(`/assemble/api/v1/account/portal/members/${id}`)
        .then((res) => {
          this.$set(this, 'member', _.merge({}, this[`${this.currentNational}Data`], res.data.data));
          if (_.isUndefined(_.get(this.member, 'meta.showImg'))) {
            this.meta = { ...this.meta, showImg: true };
          }
          this.loaded = true;
          this.$store.commit('loading', false);
        })
        .catch((e) => {
          this.$message.error(e.response.data.message);
          this.$store.commit('loading', false);
        });
    }
  },

};
</script>

<style scoped lang="scss">
.el-date-editor,
.el-select,
.el-input {
  width: 100%;
}

.main-content {
  width: 100%;
}

.avatar-section {
  position: relative;
  display: inline-block;
  height: 70px;
  width: 70px;
  border-radius: 50%;
  overflow: hidden;
  .upload-button {
    position: absolute;
    display: inline-block;
    background-color: rgb(45, 58, 69, 0.35);
    bottom: 0;
    right: 0;
    height: 22px;
    width: 100%;
    text-align: center;
    color: white;
    font-size: 0.7em;
    line-height: 1.75em;
    font-family: $fontLight;
    cursor: pointer;
  }
}
</style>
